module.exports = __webpack_public_path__ + "img/howtoplay-06.c5737dc5.jpg";